



import React, {useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {GripVertical,Minus,Paperclip,Plus,X} from 'lucide-react';

  
const SectionsQuizAddMore=({isLockSections,index ,
    sectionName,lockTimeSent,id,onRemove,changeItemtitle,changelockTime,setDeleteSectionPopUp})=>{
  const dispatch = useDispatch();  
  const handleMouseEnter = () =>dispatch({
    type: "CURSOR",
    
    payload:true
  });
  const handleMouseLeave = () => dispatch({
    type: "CURSOR",
    
    payload:false
  });
    const [itemtitle, setItemtitle] = useState(sectionName); 
  


    
     useEffect(()=>{
     
     },[])



     const [text, setText] = useState("");
     const [wordCount, setWordCount] = useState(0);
     const [lockTime, setlockTime] = useState(lockTimeSent);
   
     const handleChange = (event) => {
       const inputText = event.target.value;
       const words = inputText.trim().split(/\s+/); // Split by spaces, ignoring extra spaces
       const count = words[0] === "" ? 0 : words.length; // Handle empty input edge case
   
       if (count <= 50) {
         setText(inputText);
         setWordCount(count);
       }
     };
   return(<>
  
   <div 
   
   
   style={{padding:"5px",margin:"5px", marginTop:"10px",borderRadius:"10px",background:"#fff",
   boxShadow: "0 7px 20px 0 rgba(48, 25, 131, 0.053)",border:"3px solid rgba(144, 202, 249,1)"}}> 
    { <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} style={{width:"30px",height:"30px",cursor:"pointer",float:"right",borderRadius:"50%",
    margin:"10px", marginTop:"10px",
      background:"#958FDA"}} onClick={()=>{setDeleteSectionPopUp(id)}}><X  style={{margin:"6px"}} color="#ffffff" size={18}/></div>}
    
 
<div  style={{}}>
    <div style={{}}>
    
    
    </div> 
    <div>
    <div className="YoutubeVideoLinkCardInner"  > 
    
      <div onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave} 
    //   style={{width:"50px",height:"40px",marginLeft:"-15px",position:"relative",
    //   borderRadius:"50%",
    //    alignContent:"center",textAlign:"center",padding:"5px",}}
       >
          {/* <GripVertical color="#958FDA" size={32} /> */}
          </div>  
        {<textarea onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}   cols={4} rows={4} value={itemtitle} type="text"
     placeholder={(index+1)+": Add Section Name  "}
        onChange={(e)=>{handleChange(e);changeItemtitle(id,e.target.value);setItemtitle(e.target.value);}}
          style={{maxWidth:"230px",outline:0,marginTop:"2px",border:"0px solid rgba(144, 202, 249,0.81)", fontSize:"16px",fontWeight:"800"}} ></textarea>}
        
        
        
        </div>
        {/* <div  className="coloredTextV1" >
        Word count: {wordCount} / 50
      </div> */}
       {isLockSections?<div style={{height:"70px",marginTop:"10px"}}>
        <div style={{background:"#ffffff", display:"flex", justifyContent:"space-around",borderRadius:"15px",marginTop:"10px",paddingTop:"10px",paddingBottom:"10px",}}>  
                    <div style={{fontSize:"16px",fontWeight:"bold",padding:"8px",paddingTop:"15px"}}>Section Time</div>         
               <div style={{margin: '5px' ,paddingLeft:"0px",width:"150px", display:"flex", justifyContent:"space-around" ,alignItems:"center"  }}>
 <Minus  onMouseEnter={handleMouseEnter}
     onMouseLeave={handleMouseLeave}  onClick={()=>{setlockTime(parseInt(lockTime)>1?parseInt(lockTime)-5:1)
    changelockTime(id,parseInt(lockTime)>1?parseInt(lockTime)-5:1);  
  }} style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginLeft:"0px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}} color="rgba(144, 202, 249,1)" size={13}/>
    <input onMouseEnter={handleMouseEnter} disabled
     onMouseLeave={handleMouseLeave}  value={parseInt(lockTime)} type="number"
          onChange={(e)=>{changelockTime(id,parseInt(e.target.value)<360?parseInt(e.target.value):1);setlockTime(parseInt(e.target.value)<360?parseInt(e.target.value):1);}}
          style={{border:"0px dashed #555555  ",borderRadius:"10px",outline:0,width:"50px",
            padding:"0px",marginLeft:"19px",fontSize:"20px",color:"#555555 ",background:"#fff",fontWeight:"bolder",marginTop:"0px",}}
      />  <Plus onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}  onClick={()=>{setlockTime(parseInt(lockTime)<360?parseInt(lockTime)+5:360)
        changelockTime(id,parseInt(lockTime)<360?parseInt(lockTime)+5:360); 
      
      }}  style={{border:"3px solid rgba(144, 202, 249,1) ",width:"25px",height:"25px",borderRadius:"50%",marginRight:"0px",marginLeft:"-15px",
        alignContent:"center",textAlign:"center",padding:"5px",cursor:"pointer"}}  color="rgba(144, 202, 249,1)" size={13}/>
        
        
        
        </div>  <div style={{fontSize:"18px",fontWeight:"bold",padding:"8px",paddingTop:"15px"}}>Min</div> </div>
        </div>:""}
        <div  className=""style={{display:"flex",justifyContent:"right"}}>
        <div  onMouseEnter={handleMouseEnter}
               onMouseLeave={handleMouseLeave} 
               
               onClick={ ()=>{   }}
               className="QuizAddSectionBtn" style={{background:"#fff",color:"#555555",display:"flex",justifyContent:"space-between"}} > <div style={{marginTop:"4px"}}><Paperclip color={"#555"} size={16}/></div>  
               <div>Add Questions</div> </div></div>
   <div style={{float:"right",padding:"15px"}}>
   
   
    </div> 
    
     
    </div>
    
    </div>
    
    </div></>)
}  

export default SectionsQuizAddMore;
